module.exports = __webpack_public_path__ + "static/media/wechatQrcodeFFF2.c3ee77a3.jpg";